import { ICreateTripDto } from './create-trip-input-dto.interface';

export interface IUpdateTripDto extends Partial<ICreateTripDto> {
    routingErrors?: IRoutingErrorDto[];
}

export interface IRoutingErrorDto {
    locationId: string;
    locationName: string;
    latitude: string;
    longitude: string;
    timestamp: string;
    calculationType: string;
}
